import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PortDetailsService {
   private readonly baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) {}
  getPortDetails() {
    const url = `${this.baseUrl}/scperformance/port_details`;
    return this.http.get<any>(url).pipe(catchError(this.errorHandler));
  }
  errorHandler(error: HttpErrorResponse) {
    return throwError(() => error || 'Server Error');
  }
}
